import { ReportEmailStatus, SelectableReportEmailStatus } from "@models/portfolioadmin/reportManagement/reportEmailStatus";
import { EmailStatus } from "@models/portfolioadmin/reportManagement/emailStatus";

class EmailSelectDialogController implements angular.IOnInit {
  public availableEmails: SelectableReportEmailStatus[]

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService) { }

  $onInit(): void {
  }

  public displayStatus(status: EmailStatus) {
    switch (status) {
      case EmailStatus.OPENED:
        return 'Opened';
      case EmailStatus.FAILED:
        return 'Failed To Send';
      case EmailStatus.SENT:
      default:
        return 'Sent';
    }
  }

  public sendEmail() {
    const emailIds = this.availableEmails.filter(e => e.selected).map(e => e.id);
    this.$mdDialog.hide(emailIds);
  }

  public cancel() {
    this.$mdDialog.cancel();
  }
}

export const emailSelectDialog: angular.IComponentOptions = {
  controller: EmailSelectDialogController,
  template: require('./emailSelect.dialog.html'),
  bindings: {
    availableEmails: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/reportManagement/emailSelectDialog/emailSelect.dialog.ts